import './styles.styl'
import React from 'react'
import { PhotoshopPicker } from 'react-color'

export default class Colour extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      bgPickerOpen: false,
      fgPickerOpen: false,
      selectedFgColour: {
        key: props.name,
        value: props.fg
      },
      selectedBgColour: {
        key: props.name,
        value: props.bg
      }
    }
  }

  acceptColour (kind) {
    let onChange = () => {}

    if (typeof this.props.onChange === 'function') {
      onChange = this.props.onChange
    }

    if (kind === 'fg') {
      onChange(this.state.selectedFgColour, true)
    } else {
      onChange(this.state.selectedBgColour, false)
    }

    this.togglePicker(kind)
  }

  rejectColour (kind) {
    if (kind === 'fg') {
      this.setState({
        selectedFgColour: {
          key: this.props.name,
          value: this.props.fg
        }
      })
    } else {
      this.setState({
        selectedBgColour: {
          key: this.props.name,
          value: this.props.bg
        }
      })
    }

    this.togglePicker(kind)
  }

  handleChangeComplete (colour, isFg) {
    if (isFg === true) {
      this.setState({
        selectedFgColour: {
          value: colour.hex,
          key: this.props.name
        }
      })
    } else {
      this.setState({
        selectedBgColour: {
          value: colour.hex,
          key: this.props.name
        }
      })
    }
  }

  togglePicker (kind) {
    let newState = true

    if (kind === 'fg') {
      newState = !this.state.fgPickerOpen
      this.setState({
        fgPickerOpen: newState,
        bgPickerOpen: false
      })
    } else {
      newState = !this.state.bgPickerOpen
      this.setState({
        bgPickerOpen: newState,
        fgPickerOpen: false
      })
    }
  }

  render () {
    let overlay = null

    if (this.state.bgPickerOpen || this.state.fgPickerOpen) {
      overlay = (
        <div className='picker-overlay'>
          {this.state.bgPickerOpen ? <PhotoshopPicker color={this.state.selectedBgColour.value} onAccept={() => this.acceptColour('bg')} onCancel={() => this.rejectColour('bg')} onChangeComplete={colour => this.handleChangeComplete(colour, false)} /> : null}
          {this.state.fgPickerOpen ? <PhotoshopPicker color={this.state.selectedFgColour.value} onAccept={() => this.acceptColour('fg')} onCancel={() => this.rejectColour('fg')} onChangeComplete={colour => this.handleChangeComplete(colour, true)} /> : null}
        </div>
      )
    }

    return (
      <div className='colour-container'>
        <div className='colour-block'>
          <div className='colour-block-bg' style={{ backgroundColor: this.props.bg || '#FF0000' }} onClick={() => this.togglePicker('bg')} />
          <div className='colour-block-fg' style={{ backgroundColor: this.props.fg || '#0000FF' }} onClick={() => this.togglePicker('fg')} />
        </div>
        <div className='colour-label'>B {(this.props.bg || 'FF0000').replace('#', '')}</div>
        <div className='colour-label'>F {(this.props.fg || '0000FF').replace('#', '')}</div>
        {overlay}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./ui/color/index.js